import { useTranslation } from '@eti/providers';
import type { Passengers } from '../types/passengers';

export const useFormattedChildrenAges = (passengers: Passengers) => {
  const { t } = useTranslation();

  if (!passengers.children) {
    return '';
  }

  const childrenAges = Array.from({ length: passengers.children }).map(
    (_, index) => `${t('Air.Search.ChildAge', index + 1)}: ${passengers.childrenAges[index]}`,
  );

  return childrenAges.join(', ').trim();
};
